import * as types from './mutation-types'

export const calendarSetCalendars = ({commit}) => {
  commit(types.CALENDAR_LOADING_CALENDARS, true)
  Vue2.prototype.$api.active().get('calendars', {
    params: {
      include: 'sources,calendarType',
    },
  })
    .then((response) => {
      commit(types.CALENDAR_SET_CALENDARS, response.data)
      commit(types.CALENDAR_LOADING_CALENDARS, false)
    })
}

export const calendarSetCalendarDetails = ({commit}, CalendarUuid) => {
  Vue2.prototype.$api.active().get('calendars/' + CalendarUuid, {
    params: {
      include: 'sources,calendarType,groups',
    },
  }).then((response) => {
    commit(types.CALENDAR_SET_CALENDAR, response.data)
  })
}

export const calendarSetEventSources = ({commit}, CalendarUuid) => {
  Vue2.prototype.$api.active().get('calendars/' + CalendarUuid + '/sources')
    .then((response) => {
      let eventSources = response.data.data.map(function (source) {
        return {
          events(start, end, timezone, callback) {
            Vue2.prototype.$api.active().get(`calendars/${CalendarUuid}/sources/${source.uuid}/events`,
              {params: {timezone: timezone}}).then((response) => {
              callback(response.data.data)
            })
          },
        }
      })
      commit(types.CALENDAR_SET_EVENT_SOURCES, eventSources)
    })
}

export const calendarSetCalendarTypes = ({commit}) => {
  Vue2.prototype.$api.active().get('calendars/types')
    .then((response) => {
      commit(types.CALENDAR_SET_CALENDAR_TYPES, response.data.data)
    })
}
